import * as React from 'react'
import Flink from '~/components/shared/flink'
import { usePost } from '~/contexts/PostContext'
import { jnstyls, notBlank, imgSize } from '~/utils/helpers'

import * as styles from "~/styles/blog/blog-faketiles.module.scss"
import * as bstyle from "~/styles/blog/blog.module.scss"


const FakeTiles = ({ blockId, index }) => {
  const { post } = usePost()
  const block = post.data.blocks.find(x => x.id === blockId)
  const { settings } = block

  let tiles = []

  if (notBlank(settings.image1)) {
    const obj = {
      image: notBlank(settings.image1) ? settings.image1 : null,
      title: notBlank(settings.title1) ? settings.title1 : null,
      link: notBlank(settings.link1) ? settings.link1 : null,
      price: notBlank(settings.price1) ? settings.price1 : null,
      color: notBlank(settings.color1) ? settings.color1 : null
    }
    tiles.push(obj)
  }
  if (notBlank(settings.image2)) {
    const obj = {
      image: notBlank(settings.image2) ? settings.image2 : null,
      title: notBlank(settings.title2) ? settings.title2 : null,
      link: notBlank(settings.link2) ? settings.link2 : null,
      price: notBlank(settings.price2) ? settings.price2 : null,
      color: notBlank(settings.color2) ? settings.color2 : null
    }
    tiles.push(obj)
  }
  if (notBlank(settings.image3)) {
    const obj = {
      image: notBlank(settings.image3) ? settings.image3 : null,
      title: notBlank(settings.title3) ? settings.title3 : null,
      link: notBlank(settings.link3) ? settings.link3 : null,
      price: notBlank(settings.price3) ? settings.price3 : null,
      color: notBlank(settings.color3) ? settings.color3 : null
    }
    tiles.push(obj)
  }
  if (notBlank(settings.image4)) {
    const obj = {
      image: notBlank(settings.image4) ? settings.image4 : null,
      title: notBlank(settings.title4) ? settings.title4 : null,
      link: notBlank(settings.link4) ? settings.link4 : null,
      price: notBlank(settings.price4) ? settings.price4 : null,
      color: notBlank(settings.color4) ? settings.color4 : null
    }
    tiles.push(obj)
  }

  return (
    <div className={jnstyls([styles.blog_tiles, bstyle.sec])} block={block.id}>
      {tiles.length > 0 && tiles.map( (tile,index) =>
        <div key={`st${tile.link}${index}`}>
          <Flink 
            href={tile.link}
          >
            <img 
              className={`${styles.img}`}
              src={imgSize(tile.image,900)} 
              alt={tile.title}
              width={300} height={500} 
            />
          </Flink>
          <div>
            <div className={styles.title}>{tile.title}</div>
            <div className={styles.price}>${tile.price}</div>
            <div className={styles.color}>{tile.color}</div>
          </div>
        </div>
      )}
    </div>
  )
}

export default FakeTiles


